import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConectService } from '../../../services/conect.service'

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent implements OnInit {

  formulario: FormGroup;

  private correoPatron: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private telefonoPatron: any = /^[0-9]{11}$/;

  constructor(private constructorFormulario: FormBuilder, private servicioMensaje: ConectService) {
    this.formulario = this.constructorFormulario.group({
      correo: new FormControl('', [Validators.required, Validators.pattern(this.correoPatron)]),
      nombre: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(20)]),
      telefono: new FormControl('', [Validators.required, Validators.pattern(this.telefonoPatron)]),
      mensaje: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(280)]),
    });
  }

  get correo() { return this.formulario.get('correo'); }
  get nombre() { return this.formulario.get('nombre'); }
  get mensaje() { return this.formulario.get('mensaje'); }
  get telefono() { return this.formulario.get('telefono'); }

  ngOnInit(): void {
  }

  enviarFormulario() {
    this.servicioMensaje.sendEmail(this.formulario.value).subscribe(estado => {
      (estado) ? alert("MENSAJE ENVIADO CORRECTAMENTE") : alert("NO SE PUDO ENVIAR EL MENSAJE")

    })
  }

}
